import { NavLink, useLocation } from 'react-router';
import { TOOL_NAV_ITEMS } from '../constants/navigation';
import './ToolSwitcher.css';

function ToolSwitcher({ items = TOOL_NAV_ITEMS }) {
  const { pathname } = useLocation();
  const activeIndex = items.findIndex(({ to }) => to === pathname);

  const setTransitionDirection = (nextIndex) => {
    if (activeIndex === -1 || nextIndex === activeIndex) {
      return;
    }

    document.documentElement.dataset.toolTransitionDirection =
      nextIndex > activeIndex ? 'forward' : 'backward';
  };

  return (
    <div className="tool-switcher" role="group" aria-label="App sections">
      {items.map(({ id, to, label }, index) => (
        <NavLink
          key={id}
          to={to}
          end
          viewTransition
          onClick={() => setTransitionDirection(index)}
          className={({ isActive }) =>
            `tool-switcher__link${isActive ? ' tool-switcher__link--active' : ''}`
          }
        >
          {label}
        </NavLink>
      ))}
    </div>
  );
}

export default ToolSwitcher;
